import { createSlice } from '@reduxjs/toolkit'

import {
  fetchAccounts,
  installApplication,
} from 'apps/applicationInstallation/actions/applicationInstallationActions'
import { ApplicationAccount } from 'shared/api/requests/applications/schemas'

const initialState: {
  items: ApplicationAccount[]
  selectedId: string | null
  isFetching: boolean
} = {
  items: [],
  selectedId: null,
  isFetching: false,
}

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(installApplication.pending, (state, action) => {
      state.isFetching = true

      const { accountId } = action?.meta?.arg ?? {}
      if (accountId) {
        state.selectedId = accountId
      }
    })

    builder.addCase(installApplication.fulfilled, (state) => {
      state.isFetching = false
    })

    builder.addCase(fetchAccounts.pending, (state) => {
      state.isFetching = true
      state.selectedId = null
      state.items = []
    })

    builder.addCase(fetchAccounts.fulfilled, (state, action) => {
      state.isFetching = false
      const accounts = action?.payload?.accounts
      if (!accounts) {
        return
      }

      state.selectedId = null
      state.items = accounts || []
    })
  },
})

export const { reducer } = accountsSlice
